export default __webpack_public_path__ + "03be38ab.jpg";